import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { InstagramStoryContainerComponent } from '../instagram-story-container/instagram-story-container.component';
import { InstaPromoImageModel, InstaPromoModel, InstaStoryContentModel } from '../shared/model/insta-promo.model';
import { StoryModel } from '../shared/model/story.model';

@Component({
    selector: 'cc-instagram-data',
    templateUrl: 'instagram-data.component.html',
    standalone: true,
    imports: [NgIf, InstagramStoryContainerComponent],
})
export class InstagramDataComponent implements OnInit, OnChanges {
    @Input() gamingStoriesData: any;
    @Input() config: any;
    @Output() dataNotExists = new EventEmitter<string>();

    storyDataModel: StoryModel = new StoryModel();
    displayInstaStories: boolean;

    constructor() {}

    ngOnInit() {
        this.setInstagramStoriesData();
    }

    ngOnChanges() {
        this.setInstagramStoriesData();
    }

    setInstagramStoriesData() {
        this.dataNotExists.emit('loaded');
        if (this.gamingStoriesData && this.gamingStoriesData.instaContainer && this.gamingStoriesData.instaPromoList) {
            this.displayInstaStories = true;
            this.storyDataModel.sharedList = this.gamingStoriesData.instaContainer.sharedList;
            this.storyDataModel.storyDisplayInterval = this.gamingStoriesData.instaContainer.storyDisplayInterval;
            this.storyDataModel.storyIconShape = this.gamingStoriesData.instaContainer.storyIconShape;
            this.storyDataModel.versionedList = this.gamingStoriesData.instaContainer.versionedList;
            this.storyDataModel.instaPromoList = this.setPromoData(this.gamingStoriesData.instaPromoList);
        }
    }

    setPromoData(promoData: any): Array<InstaPromoModel> {
        const instaPromoList: Array<InstaPromoModel> = new Array<InstaPromoModel>();
        promoData.forEach((promo: any) => {
            const instaPromoImageModel: InstaPromoImageModel = new InstaPromoImageModel();
            const instaPromoModel: InstaPromoModel = new InstaPromoModel();
            if (promo.storyThumbnailImage) {
                instaPromoImageModel.src = promo.storyThumbnailImage.src;
                instaPromoImageModel.alt = promo.storyThumbnailImage.alt;
                instaPromoImageModel.width = promo.storyThumbnailImage.width;
                instaPromoImageModel.height = promo.storyThumbnailImage.height;
            }
            instaPromoModel.promoItemId = promo.promoItemId;
            instaPromoModel.promoTitle = promo.promoTitle;
            instaPromoModel.instaPromoImageModel = instaPromoImageModel;
            if (promo.instaStoryList) {
                const instaStoryContentList: Array<InstaStoryContentModel> = new Array<InstaStoryContentModel>();
                promo.instaStoryList.forEach((story: any) => {
                    if (story.isValid) {
                        const instaStoryContent: InstaStoryContentModel = new InstaStoryContentModel();
                        instaStoryContent.mainStoryContentPath = story.mainStoryContentPath.path;
                        instaStoryContent.mainStoryItemName = story.mainStoryContentPath.itemName;
                        if (story.swipeUpContentPath) {
                            instaStoryContent.swipeUpContentPath = story.swipeUpContentPath.path;
                            instaStoryContent.swipeUpItemName = story.swipeUpContentPath.itemName;
                        }
                        instaStoryContent.enableSwipeUp = story.enableSwipeUp;
                        if (story.targetPromoId && story.targetPromoType && story.targetPromoStatus) {
                            instaStoryContent.targetPromoId = story.targetPromoId;
                            instaStoryContent.targetPromoType = story.targetPromoType;
                            instaStoryContent.targetPromoStatus = story.targetPromoStatus;
                        }
                        instaStoryContentList.push(instaStoryContent);
                    }
                });
                instaPromoModel.instaStoryContentModel = instaStoryContentList;
            }
            if (instaPromoModel.instaStoryContentModel.length > 0) {
                instaPromoList.push(instaPromoModel);
            }
        });
        return instaPromoList;
    }
}
